(ns app.front.view.group.admin.config.notification
  "See `app.front.view.group.admin.config.notifications` for a more generic notification config system"
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]))

(defn notification-config [{:keys [tr *group-config parent-config target] :as ctx}]
  (let [parent-notifs? (-> parent-config :group.config/permit-notifications?)
        checked        (boolean (some true? (vector (:group.config/permit-notifications? @*group-config)
                                                    parent-notifs?)))]
    (cc/form-group
      {:legend-text (tr [:group-admin/notifications])}
      [acommon/checkbox ctx :group.config/permit-notifications?]
      (when checked
        [:<>
         [ui/number-input {:id                 (str "permit-issued-notification-" target)
                           :label-text         (tr [:group-admin/notifications-permit-issued])
                           :unit-label         (tr [:group-admin/notifications-permit-issued-unit-label])
                           :wrapper-class-name "long mb-4"
                           :disabled           (->> (vector (:group.config/permit-notifications? @*group-config)
                                                            parent-notifs?)
                                                    (some true?)
                                                    not)
                           :on-change          #(swap! *group-config assoc :group.config/permit-issued-notification-interval (-> %
                                                                                                                                 futil/tval
                                                                                                                                 futil/parse-int))
                           :value              (or (:group.config/permit-issued-notification-interval @*group-config)
                                                   (-> parent-config :group.config/permit-issued-notification-interval))}]
         [ui/number-input {:id                 (str "permit-completion-notification-" target)
                           :label-text         (tr [:group-admin/notifications-completion-date])
                           :unit-label         (tr [:group-admin/notifications-completion-date-unit-label])
                           :wrapper-class-name "long"
                           :disabled           (->> (vector (:group.config/permit-notifications? @*group-config)
                                                            parent-notifs?)
                                                    (some true?)
                                                    not)
                           :on-change          #(swap! *group-config assoc :group.config/completion-date-notification-interval (-> %
                                                                                                                                   futil/tval
                                                                                                                                   futil/parse-int))
                           :value              (or (:group.config/completion-date-notification-interval @*group-config)
                                                   (-> parent-config :group.config/completion-date-notification-interval))}]]))))
